import script from "./ScoreQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreQuestion.vue?vue&type=script&setup=true&lang=js"

import "./ScoreQuestion.vue?vue&type=style&index=0&id=34d7b836&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d7b836"]])

export default __exports__